import Avo, { AvoEnv, NavigationType, NavigationTypeType, Products, DeviceCategoryValueType } from "./jacksonAvo";
import jacksonData from "./data-map/jacksonData";


declare global {
  interface Window {
    analytics: any;
    navigationTracking: {
      navigationFlyout?: string;
      navigationGroup?: string;
    };
  }
}


let segmentAnalytics: any;


function setShopifyCustomPixelValues() {
  const jwtAll = document.getElementById('react-jwt-all');
  let segmentWriteKey = jacksonData.segmentProd;
  if (window.location.href.includes('garage')) {
    segmentWriteKey = jacksonData.segmentDev;
  }

  const shopifyCustomerID = jwtAll?.getAttribute('data-customer') || '';
  localStorage.setItem('shopifyCustomerID', shopifyCustomerID);
  localStorage.setItem('siteID', 'jackson_shop');
  localStorage.setItem('segmentWriteKey', segmentWriteKey);
}



function loadSegmentAnalytics() {
  let segmentWriteKey = jacksonData.segmentProd;
  if (window.location.href.includes('garage')) {
    segmentWriteKey = jacksonData.segmentDev;
  }

  segmentAnalytics = window.analytics = window.analytics || [];

  if (segmentAnalytics.initialize) {
    initializeAvo();
    return;
  }

  if (segmentAnalytics.invoked) {
    initializeAvo();
    return;
  }

  segmentAnalytics.invoked = true;
  segmentAnalytics.methods = [
    "trackSubmit", "trackClick", "trackLink", "trackForm", "pageview",
    "identify", "reset", "group", "track", "ready", "alias", "page",
    "once", "off", "on"
  ];

  segmentAnalytics.factory = function (t: string) {
    return function () {
      const e = Array.prototype.slice.call(arguments);
      e.unshift(t);
      segmentAnalytics.push(e);
      return segmentAnalytics;
    };
  };

  for (let t = 0; t < segmentAnalytics.methods.length; t++) {
    const e = segmentAnalytics.methods[t];
    segmentAnalytics[e] = segmentAnalytics.factory(e);
  }

  segmentAnalytics.load = function (t: string) {
    const e = document.createElement("script");
    e.type = "text/javascript";
    e.async = true;
    e.src = (document.location.protocol === "https:" ? "https://" : "http://") +
            "cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
    const n = document.getElementsByTagName("script")[0];
    if (n.parentNode) {
      n.parentNode.insertBefore(e, n);
    }
  };

  segmentAnalytics.SNIPPET_VERSION = "3.1.0";
  segmentAnalytics.load(segmentWriteKey);
  console.log('Segment SDK Loaded');

  // Now call Avo init
  initializeAvo();
}

function initializeAvo() {
  var webDebugger = document.getElementById('segment-source')?.getAttribute('data-avo-web-debugger') === 'true' ? true : false;
  const customDestination = {
    logEvent: (eventName: string, eventProperties: object) => {
      segmentAnalytics.track(eventName, eventProperties);
    },
    logPage: (pageName: string, pageProperties: object) => {
      segmentAnalytics.page(pageName, pageProperties);
    },
    setUserProperties: (userId: string, userProperties: object) => {
      if(!!userId) {
      segmentAnalytics.identify(userId, userProperties);
      }
    },
    identify: (userId: string) => {
    },
    unidentify: () => {
      segmentAnalytics.reset();
    },
    setGroupProperties: (groupType: string, groupId: string, groupProperties: object) => {
      segmentAnalytics.group(groupId, groupProperties);
    },
    addCurrentUserToGroup: (groupType: string, groupId: string) => {
      segmentAnalytics.group(groupId);
    },
    logEventWithGroups: () => {
      // Not supported by the Segment SDK
    }
  };

  let device: DeviceCategoryValueType = 'desktop';

  const userAgent = window.navigator.userAgent.toLowerCase();

  if (/mobile|android|iphone|ipod/.test(userAgent)) {
      device = 'mobile';
  } else if (/tablet|ipad/.test(userAgent)) {
      device = 'tablet';
  }

const locale = document.querySelector('header')?.getAttribute('data-locale') || 'en_US';
let jacksonMarketId = 'jackson_emea';
if (locale.includes('US')) {
  jacksonMarketId = 'jackson_us';
} else if (locale.toLowerCase().includes('japan')) {
  jacksonMarketId = 'jackson_jp';
} else if (locale.toLowerCase().includes('australia')) {
  jacksonMarketId = 'jackson_au';
}
  Avo.initAvo({ env: AvoEnv.Dev, webDebugger }, { deviceCategory: device, siteId: "jackson_shop", marketId: jacksonMarketId }, customDestination, customDestination);
}

function getUTMParameter(param: string) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(param) ? urlParams.get(param) : null;
}

function collectCommonData() {
  const prsID = localStorage.getItem('prsID') || '';
  const cartData = localStorage.getItem('cart');
  const productData = localStorage.getItem('product') ? JSON.parse(localStorage.getItem('product') as string) : null;
  const collectionData = localStorage.getItem('collection') ? JSON.parse(localStorage.getItem('collection') as string) : null;
  const category = collectionData?.title || '';
  const currency = document.querySelector('#segment-source')?.getAttribute('data-currency') || 'USD';
  const path = window.location.pathname;
  const url = window.location.href;
  const referrer = !!document.referrer ? document.referrer : null;
  const date = new Date().toISOString();
  const headerElement = document.querySelector('header');
  const locale = headerElement?.getAttribute('data-locale') || 'en_US';
  const region = headerElement?.getAttribute('data-region') || 'US';
  let name = headerElement?.getAttribute('data-page-name') || null;
  const customer = headerElement?.getAttribute('data-customer') || '';
  localStorage.setItem('shopifyLocale', locale);

  if (!name) {
    const cleanUrl = url.split('?')[0];
    const parts = cleanUrl.split('/');
    if (parts.includes('blogs')) {
      name = 'blogs';
    } else {
      name = parts.length <= 3 || parts[parts.length - 1] === '' ? 'home' : parts[parts.length - 1];
    }
  }


  return {
    cartData,
    productData,
    currency,
    path,
    url,
    referrer,
    date,
    locale,
    region,
    name,
    customer,
    utmMedium: getUTMParameter('utm_medium'),
    utmChannel: getUTMParameter('utm_channel'),
    utmCampaign: getUTMParameter('utm_campaign'),
    utmSource: getUTMParameter('utm_source'),
    utmId: getUTMParameter('utm_id'),
    utmTerm: getUTMParameter('utm_term'),
    category,
    prsID
  };
}

const handleLoadedAPage = (data: any) => {
  const { path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, utmTerm, utmId } = data;
  const name = 'Loaded A Page';
  if (!!document.querySelector('header')) {
  Avo.loadedAPage({
    name,
    path,
    url,
    referrer,
    date,
    locale,
    utmMedium,
    utmChannel,
    utmCampaign,
    utmSource,
    utmTerm,
    utmId,
    customDestinationPageName_: name,
    sectionId: 'shop'
  });
}
}

function handleProductViewed(data : any) {
  const { name, productData, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, utmId, utmTerm, currency } = data;

  const getVariantFromQueryString = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant') || productData?.variants?.[0]?.id?.toString() || '';
  };

  function getProductTitle() {
    let titleElement = document.querySelector('.product__title h1') ||
                       document.querySelector('.product__title a h2');
    return titleElement?.textContent?.trim() || productData.title;
  }

  function getSkuByVariant() {
    const variantId = getVariantFromQueryString();
    const selectedVariant = productData.variants.find((variant: { id: number }) => variant.id.toString() === variantId);
    return selectedVariant?.sku || productData.variants?.[0]?.sku || '';
  }

  function getPriceByVariant(productData: any) {
    const variantId = getVariantFromQueryString();
    const selectedVariant = productData?.variants?.find(
      (variant: any) => variant.id.toString() === variantId
    );
    return selectedVariant ? selectedVariant.price : '';
  }

  const getPrice = () => {
    let priceElement = document.querySelector(
      '.price-main .price__sale, .price-main .price-item--sale'
    );
    if (!priceElement) {
      priceElement = document.querySelector(
        '.price-main .price-item--regular, .price-main .money'
      );
    }
    if (!priceElement || !priceElement.textContent) return null;
  
    const rawText = priceElement.textContent.trim();
  
    const match = rawText.match(/[\d.,]+/);
    if (!match) return null;
  
    const numericChunk = match[0];
  
    const lastDotPos = numericChunk.lastIndexOf('.');
    const lastCommaPos = numericChunk.lastIndexOf(',');
  
    if (lastDotPos === -1 && lastCommaPos === -1) {
      const parsed = parseFloat(numericChunk);
      return isNaN(parsed) ? null : round2(parsed);
    }
  
    const decimalSeparator =
      lastDotPos > lastCommaPos ? '.' : ',';
  
    const separatorIndex =
      decimalSeparator === '.' ? lastDotPos : lastCommaPos;
  
    let integerPart = separatorIndex !== -1
      ? numericChunk.slice(0, separatorIndex)
      : numericChunk;
    let fractionPart = separatorIndex !== -1
      ? numericChunk.slice(separatorIndex + 1)
      : '';
  
    integerPart = integerPart.replace(/[.,]/g, '');
  
    if (!fractionPart) fractionPart = '0';
  
    const normalized = `${integerPart}.${fractionPart}`;
  
    const parsedPrice = parseFloat(normalized);
    return isNaN(parsedPrice) ? null : round2(parsedPrice);
  
    function round2(num : any) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    }
  };
  

  const fireProductViewedEvent = () => {
    loadSegmentAnalytics();
    console.log(productData);
    if (document.querySelector('section[data-product-viewed]') && productData) {
      const product = {
        currency: currency,
        price: getPrice() || 0,
        quantity: 1,
        variant: getVariantFromQueryString(),
        category: productData.type || '',
        position: 1,
        productName: getProductTitle(),
        productType: productData?.type?.includes('Software') ? 'digital' : 'physical',
        upsell: false,
        sku: getSkuByVariant(),
        productId: productData.id
      };

      Avo.productViewed({
        path,
        url,
        name,
        referrer,
        utmMedium,
        utmChannel,
        utmCampaign,
        utmId,
        utmTerm,
        date,
        utmSource,
        locale,
        products: [product],
        categoryTag: productData.tags || [],
        sectionId: 'shop'
      });
    }
  };

  const modifyHistoryMethod = (type: 'pushState' | 'replaceState') => {
    const original = history[type];
    return function (this: History) {
      const result = original.apply(this, arguments as unknown as [any, string, (string | URL | null | undefined)?]);
      window.dispatchEvent(new Event(type));
      return result;
    };
  };

  history.pushState = modifyHistoryMethod('pushState');
  history.replaceState = modifyHistoryMethod('replaceState');

  fireProductViewedEvent();

  window.addEventListener('popstate', fireProductViewedEvent);
  window.addEventListener('pushState', fireProductViewedEvent);
  window.addEventListener('replaceState', fireProductViewedEvent);
}

function handleCartViewed(data: any) {
  const { cartData, path } = data;
  if (path.includes('/cart') && cartData) {
    const cart = JSON.parse(cartData);
    const productsArray: Products[] = cart.items.map((item: any, index: number) => ({
      currency: cart.currency,
      price: item.price / 100,
      quantity: item.quantity,
      variant: item.variant_id,
      category: item.product_type || '',
      position: index + 1,
      productName: item.product_title,
      productType: item?.type?.includes('Software') ? 'digital' : 'physical',
      upsell: false,
      sku: item.sku,
      productId: item.product_id
    }));

    loadSegmentAnalytics();
    Avo.cartViewed({
      products: productsArray,
      total: cart.total_price / 100,
      subtotal: cart.items_subtotal_price / 100,
      currency: cart.currency,
      path: data.path,
      url: data.url,
      referrer: data.referrer,
      utmMedium: data.utmMedium,
      utmChannel: data.utmChannel,
      utmCampaign: data.utmCampaign,
      utmTerm: data.utmTerm,
      utmId: data.utmId,
      date: data.date,
      utmSource: data.utmSource,
      locale: data.locale,
      name: 'Cart',
      sectionId: 'shop'
    });
  }
}

function handleNavigationClicked(data: any) {
  const { name, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, utmId, utmTerm } = data;
  const desktopMenuContent = document.getElementById("contentful-desktop-menu-target");
  if (desktopMenuContent) {
    desktopMenuContent.addEventListener("click", (event: Event) => {
      loadSegmentAnalytics();
      console.log('MenuContent clicked');
      const target = event.target as HTMLElement;

      let navigationType: NavigationTypeType[keyof typeof NavigationType] = NavigationType.MAIN;
      let navigationFlyout: string | null = target.closest(".level-1-wrapper")?.querySelector("[data-navigation-flyout]")?.getAttribute("data-navigation-flyout") || '';
      let navigationGroup: string | null = target.closest(".level-2-wrapper")?.querySelector("[data-navigation-group]")?.getAttribute("data-navigation-group") || '';
      let navigationCore: string | null = target.closest("details[data-navigation-core]")?.getAttribute("data-navigation-core") || '';
      if (navigationGroup) {
        navigationType = NavigationType.SUB;
      }
      if (!navigationGroup && !navigationFlyout) {
        navigationType = NavigationType.SHOP;
      }
      if (target.tagName === "IMG") {
        navigationType = NavigationType.IMAGE;
      }

        console.log(target.tagName);
        if (target.tagName === "SPAN" && (target.classList.contains("level-1-target") || target.classList.contains("level-3-target"))) {
        Avo.navigationClicked({
          path,
          url,
          referrer,
          utmMedium,
          utmChannel,
          utmCampaign,
          utmId,
          utmTerm,
          date,
          name,
          utmSource,
          locale,
          navigationGroup: navigationGroup,
          navigationType: navigationType,
          navigationFlyout: navigationFlyout,
          navigationLabel: target.innerText,
          navigationCore: 'Shop',
          sectionId: 'shop'
        });
      }
    });
  }

  const mobileMenuContent = document.getElementById("contentful-mobile-menu-render-target");
 
  if (mobileMenuContent) {
    if (!window.navigationTracking) {
      window.navigationTracking = {};
    }
    
    let navigationType: NavigationTypeType[keyof typeof NavigationType] = NavigationType.MAIN;
    let navigationFlyout: string | null = '';
    let navigationGroup: string | null = '';
    mobileMenuContent.addEventListener("click", (event: Event) => {
      loadSegmentAnalytics();
      console.log('MenuContent clicked');
      const target = event.target as HTMLElement;

      

     if(target.closest(".level-1")) {
      navigationFlyout = target.innerText || '';
      window.navigationTracking.navigationFlyout = navigationFlyout;
      window.navigationTracking.navigationGroup = '';
     }
     if(target.closest(".level-2")) {
      navigationGroup = target.innerText || '';
      window.navigationTracking.navigationGroup = navigationGroup;
      } 
      if(target.closest(".level-3")) {

      }
      
      if (navigationGroup) {
        navigationType = NavigationType.SUB;
      }
      if (!navigationGroup && !navigationFlyout) {
        navigationType = NavigationType.SHOP;
      }
      if (target.tagName === "IMG") {
        navigationType = NavigationType.IMAGE;
      }

        console.log(target.tagName);
        if (target.tagName === "SPAN" || target.tagName === "A") {
        Avo.navigationClicked({
          path,
          url,
          referrer,
          utmMedium,
          utmChannel,
          utmCampaign,
          utmId,
          utmTerm,
          date,
          name,
          utmSource,
          locale,
          navigationGroup: window.navigationTracking.navigationGroup,
          navigationType: navigationType,
          navigationFlyout: window.navigationTracking.navigationFlyout,
          navigationLabel: target.innerText,
          navigationCore: 'Shop',
          sectionId: 'shop'
        });
      }
    });
  }
}

function handleDealerLocatorEvents(data: any) {
  const { name, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, productData, utmId, utmTerm } = data;
  const triggerAvoDealerSearched = (action: string, ctaText: string, ctaLocation: string, position: number | null = null, category: string | null = null, sku: string | null = null) => {
    Avo.dealerSearched({
      path,
      url,
      referrer,
      utmMedium: utmMedium || '',
      utmChannel: utmChannel || '',
      utmCampaign: utmCampaign || '',
      utmId,
      utmTerm,
      date: new Date().toISOString(),
      utmSource: utmSource || '',
      locale: locale || 'en_US',
      action,
      category,
      ctaText,
      position,
      ctaLocation: ctaLocation || '',
      sku,
      name,
      sectionId: 'shop'
    });
  };

  document.querySelector('footer')?.addEventListener('click', () => {
    localStorage.setItem('dealerSource', 'footer');
  });

  document.querySelector('svg.icon-dealer')?.addEventListener('click', () => {
    localStorage.setItem('dealerSource', 'search');
  });

  const submitButton = document.getElementById('dealerLocatorSubmit');
  const useLocationContainer = document.getElementById('use-location__container');
  const dealerFormInput = document.getElementById('dealerFormInput');

  const dealerSearchTrigger = () => {
    loadSegmentAnalytics();
    const source = localStorage.getItem('dealerSource') || 'search';
    triggerAvoDealerSearched('Dealers', 'Search', source);
  };

  submitButton?.addEventListener('click', dealerSearchTrigger);
  useLocationContainer?.addEventListener('click', (event) => {
    event.stopPropagation();
    dealerSearchTrigger();
  });
  dealerFormInput?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      dealerSearchTrigger();
    }
  });

  document.getElementById('dealer-locator-react')?.addEventListener('click', (event) => {
    const target = event.target as Element;
    const element = target.closest('[data-distributor-clicked]');
    const continent = target.closest('[data-continent]')?.getAttribute('data-continent') || '';
    const position = target.closest('[data-position]')?.getAttribute('data-position');

    if (element) {
      triggerAvoDealerSearched('Distributors', 'View Region', continent, position ? parseInt(position) : 1);
    }
  });

  const handleDealerSearch = (event: Event) => {
    const target = event.target as Element;
    const clickElement = target.closest('#dealerLocatorSubmit') || target.closest('#use-location__container');
    const keydownElement = target.closest('#dealerFormInput');

    const isClickEvent = event.type === 'click' && clickElement;
    const isKeydownEvent = event.type === 'keydown' && keydownElement && (event as KeyboardEvent).key === 'Enter';

    if (isClickEvent || isKeydownEvent) {
      triggerAvoDealerSearched('Dealers', 'Search', 'PDP', null, productData?.type || null, productData?.variants[0]?.sku || null);
    }
  };

  const modalElement = document.getElementById('dealer-portal-pdp-modal');
  modalElement?.addEventListener('click', handleDealerSearch);
  modalElement?.addEventListener('keydown', handleDealerSearch);

  document.getElementById('omacronlink')?.addEventListener('click', () => {
    triggerAvoDealerSearched('Distributors', 'Find Online', 'PDP', null, productData?.type || null, productData?.variants[0]?.sku || null);
  });

  document.getElementById('dealer-finder')?.addEventListener('click', (event) => {
    const target = event.target as Element;
    const linkElement = target.closest('a[data-component-id="linkWrapper"]') as HTMLAnchorElement;

    if (linkElement) {
      const links = Array.from(document.querySelectorAll('#dealer-finder a[data-component-id="linkWrapper"]'));
      const position = links.indexOf(linkElement) + 1;
      const ctaText = linkElement.href;

      triggerAvoDealerSearched('Dealers', ctaText, 'All Access Dealers', position);
    }
  });
}



 
// function handleProductAdded(data: any) {
//   const { name, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, productData, currency } = data;

//   const buttons = document.querySelectorAll<HTMLButtonElement>('.product-form__submit');
//   buttons.forEach(button => {
//     button.addEventListener('click', (event) => {
//       loadSegmentAnalytics();
//       const eventTarget = event.currentTarget as HTMLElement;
//       const parentDiv = eventTarget.closest('div[data-currency]') as HTMLDivElement;

//       const category = parentDiv.getAttribute('data-product-type') || '';
//       const price = parentDiv.getAttribute('data-price');
//       const buttonCurrency = parentDiv.getAttribute('data-currency') || currency;
//       const name = parentDiv.getAttribute('data-product-name') || '';
//       const queryString = window.location.search;
//       const urlParams = new URLSearchParams(queryString);
//       const variant = urlParams.get('variant') || '';
//       const mySource = 'pdp';

//       const product: Products = {
//         currency: buttonCurrency,
//         price: price ? parseFloat((Number(price) / 100).toFixed(2)) : 0.00,
//         quantity: 1,
//         variant: variant,
//         category: category,
//         position: 1,
//         productName: name,
//         productType: productData?.type?.includes('Software') || productData?.type?.includes('Subscription') ? 'digital' : 'physical',
//         upsell: false,
//         sku: productData?.variants[0]?.sku || ''
//       };

//       Avo.productAdded({
//         products: [product],
//         total: price ? parseFloat((Number(price) / 100).toFixed(2)) : 0.00,
//         subtotal: price ? parseFloat((Number(price) / 100).toFixed(2)) : 0.00,
//         currency: buttonCurrency,
//         path: path,
//         url: url,
//         referrer: referrer,
//         utmMedium: utmMedium,
//         utmChannel: utmChannel,
//         utmCampaign: utmCampaign,
//         date: date,
//         utmSource: utmSource,
//         locale: locale,
//         categoryTag: productData.tags || [] as string[],
//         source: mySource,
//         name
//       });
//     });
//   });
// }

// function handleFileDownloaded(data: any) {
//   const { customer, productData, prsID } = data;

//   document.querySelectorAll('[data-file-downloaded]').forEach((element) => {
//     element.addEventListener('click', () => {
//       loadSegmentAnalytics();
//       const ctaLocation = element.getAttribute('data-file-header') || '';
//       const ctaText = element.getAttribute('data-cta-text') || '';

//       Avo.fileDownloaded({
//         path: data.path,
//         url: data.url,
//         referrer: data.referrer,
//         utmMedium: data.utmMedium,
//         utmChannel: data.utmChannel,
//         utmCampaign: data.utmCampaign,
//         date: data.date,
//         utmSource: data.utmSource,
//         locale: data.locale,
//         sku: productData?.variants[0]?.sku || '',
//         productName: productData?.title || '',
//         category: productData?.type || '',
//         ctaLocation: ctaLocation,
//         ctaText: ctaText,
//         userId_: prsID,
//         shopifyId: customer,
//         name: data.name
//       });
//     });
//   });
// }

function handleProductSearched(data: any) {
  const { name, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, utmTerm, utmId } = data;

  const searchContainer = document.getElementById('bc-instant-search');
  if (searchContainer) {
    searchContainer.addEventListener('click', (event) => {
      loadSegmentAnalytics();
      const searchInput = document.getElementById('boost-sd__search-widget-init-input-2') as HTMLInputElement;
      let searchQuery = searchInput ? searchInput.value : '';

      const target = event.target as HTMLElement;

      if (target.tagName === 'A') {
        const commonQuery = target.innerText;
        Avo.productSearched({
          path,
          url,
          referrer,
          utmMedium,
          utmChannel,
          utmCampaign,
          utmId,
          utmTerm,
          date,
          utmSource,
          locale: locale || 'en_US',
          query: searchQuery,
          commonQuery: commonQuery,
          name,
          sectionId: 'shop'
        });
      }

      const productItem = target.closest('.boost-sd__suggestion-queries-item--product');
      if (productItem) {
        const itemTitleElement = productItem.querySelector('.boost-sd__suggestion-queries-item-title');
        const itemTitle = itemTitleElement ? itemTitleElement.textContent?.trim() : 'Title not found';
        Avo.productSearched({
          path,
          url,
          referrer,
          utmMedium,
          utmChannel,
          utmCampaign,
          utmId,
          utmTerm,
          date,
          utmSource,
          locale: locale || 'en_US',
          query: searchQuery,
          commonQuery: itemTitle || 'View All Products',
          name,
          sectionId: 'shop'
        });
      }
    });
  }
}

let currentSearch = window.location.search;
let previousPfParams: { [key: string]: string } = {};

const paramKeyMapping = {
  'pf_m_::custom::series': 'Series',
  'pf_m_::custom::subtype': 'Subtype',
  'pf_p_price': 'Price Range',
  'pf_pt_product_type': 'Product Type',
  'pf_st_stock_status': 'Stock Status',
};

const paramValueMapping = {
  'in-stock': 'In Stock',
  'out-of-stock': 'Out of Stock',
  'Personal+Monitor+Mixer': 'Personal Monitor Mixer',
};

function makeHumanReadable(key: keyof typeof paramKeyMapping, value: any) {
  const readableKey = paramKeyMapping[key] || key;
  const readableValue = paramValueMapping[value as keyof typeof paramValueMapping] || decodeURIComponent(value);
  return { readableKey, readableValue };
}

function handleFilterChange(commonData: any) {
  const newSearch = window.location.search;
  if (currentSearch !== newSearch) {
    onUrlChange(newSearch, commonData as any);
    currentSearch = newSearch;
  }
}

function onUrlChange(queryString: string | string[][] | Record<string, string> | URLSearchParams | undefined, commonData: any) {
  const params = new URLSearchParams(queryString);
  let { name, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, category } = commonData;
  const pfParams: { [key: string]: string } = {};
  params.forEach((value, key) => {
    if (key.startsWith('pf_')) {
      pfParams[key] = value;
    }
  });

  const changedParams = getChangedParams(pfParams);

  if (changedParams.length > 0) {
    loadSegmentAnalytics();
    const data = {
      path: path,
      url: url,
      referrer: referrer,
      utmMedium: utmMedium,
      utmChannel: utmChannel,
      utmCampaign: utmCampaign,
      date: date,
      utmSource: utmSource,
      locale: locale,
      category: category,
      name: name,
    };

    changedParams.forEach(({ key, value }) => {
      const { readableKey, readableValue } = makeHumanReadable(key as keyof typeof paramKeyMapping, value);

      handleFilterClicked({
        ...data,
        filterLabel: readableValue,
        filterGroup: readableKey,
        filterType: 'text',
      });
    });

    previousPfParams = { ...pfParams };
  }
}

function getChangedParams(currentPfParams: { [key: string]: string }) {
  const changedParams: { key: string; value: any; }[] = [];
  Object.keys(currentPfParams).forEach(key => {
    if (currentPfParams[key] !== previousPfParams[key]) {
      changedParams.push({ key, value: currentPfParams[key] });
    }
  });
  return changedParams;
}

function handleFilterClicked(data: any) {
  const { name, path, url, referrer, utmMedium, utmChannel, utmCampaign, date, utmSource, locale, category, filterLabel, filterGroup, filterType, utmTerm, utmId } = data;

  Avo.filterClicked({
    path,
    url,
    referrer,
    utmMedium,
    utmChannel,
    utmCampaign,
    utmId,
    utmTerm,
    date,
    utmSource,
    locale,
    filterLabel,
    filterGroup,
    category,
    name,
    sectionId: 'shop'
  });
}

function initializePreviousPfParams() {
  const params = new URLSearchParams(window.location.search);
  params.forEach((value, key) => {
    if (key.startsWith('pf_')) {
      previousPfParams[key] = value;
    }
  });
}

window.addEventListener('popstate', handleFilterChange);

(function (history) {
  const pushState = history.pushState;
  const replaceState = history.replaceState;

  history.pushState = function (state) {
    pushState.apply(history, arguments as unknown as [any, string, (string | URL | null | undefined)?]);
    const commonData = collectCommonData();
    handleFilterChange(commonData);
  };

  history.replaceState = function (state) {
    replaceState.apply(history, arguments as unknown as [any, string, (string | URL | null | undefined)?]);
    const commonData = collectCommonData();
    handleFilterChange(commonData);
  };
})(window.history);


function handlePromotionClicked(data: any) {
  const { name, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, utmTerm, utmId } = data;

  document.body.addEventListener('click', (event) => {
    const element = (event.target as HTMLElement).closest('[data-promotion-clicked]');

    if (!element) return;

    loadSegmentAnalytics();
    const ctaText = element.getAttribute('data-cta-text') || '';
    const ctaTargetUrl = element.getAttribute('data-cta-url') || '';

    let nearestImg = null;
    let currentElement: any = element;

    while (currentElement && !nearestImg) {
      nearestImg = currentElement.querySelector('img');
      currentElement = currentElement ? currentElement.parentElement as Element : null;
    }

    const creative = nearestImg ? nearestImg.src : '';
    const nearestComponent = element.closest('[data-component-id]');
    const ctaLocation = nearestComponent ? nearestComponent.getAttribute('data-component-id') : '';
    const position = element ? Array.from(document.querySelectorAll('[data-promotion-clicked]')).indexOf(element) + 1 : -1;

    Avo.promotionClicked({
      path,
      url,
      referrer,
      utmMedium,
      utmChannel,
      utmCampaign,
      utmId,
      utmTerm,
      date,
      utmSource,
      locale,
      ctaText,
      ctaLocation: ctaLocation || '',
      name,
      creative,
      position,
      ctaTargetUrl,
      sectionId: 'shop'
    });
  }, { once: true });
}

function handleRecommendationClicked(data: any) {
  const { name, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, utmTerm, utmId } = data;

  document.body.addEventListener('click', (event) => {
    const element = (event.target as HTMLElement).closest('[data-recommendation-clicked]');
    const sku = element?.getAttribute('data-sku') || null;
    const category = element?.getAttribute('data-category') || '';
    const productName = element?.getAttribute('data-product-name') || null;
    const productType = category.includes('Software') || category.includes('Subscription') ? 'digital' : 'physical';
    const source = element?.getAttribute('data-component-id') || '';
    const position = element ? Array.from(document.querySelectorAll('[data-recommendation-clicked]')).indexOf(element) + 1 : -1;


    if (!element) return;

    loadSegmentAnalytics();

    Avo.recommendationClicked({
      path,
      url,
      referrer,
      utmMedium,
      utmChannel,
      utmCampaign,
      utmId,
      utmTerm,
      date,
      utmSource,
      locale,
      name,
      position: position,
      productName: productName,
      productType: productType,
      sku: sku,
      category: category,
      source: source,
      headerName: '',
      sectionId: 'shop'
    });

  });
}

const handleSrcCode = () => {
  const srcValue = getUTMParameter('src');
  if (srcValue) {
    localStorage.setItem('srcCode', srcValue);
  }
};




let isLoggedIn = false;
const handleLoggedIn = (data: any) => {
  const { name, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, prsID, customer } = data;
  if (isLoggedIn) return;
  if (referrer?.includes('connect') && (!!customer)) {
    // Avo.loggedIn({
    //   name,
    //   path,
    //   url,
    //   referrer,
    //   date,
    //   locale,
    //   utmMedium,
    //   utmChannel,
    //   utmCampaign,
    //   utmSource,
    //   shopifyId: customer,
    //   userId_: prsID,
    // });
    isLoggedIn = true;
  }
}

const handleLoggedOut = (data: any) => {
  const { name, path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, customer, utmTerm, utmId } = data;
  document.querySelector('[data-logged-out]')?.addEventListener('click', () => {
    loadSegmentAnalytics();
    // Avo.loggedOut({
    //   name,
    //   path,
    //   url,
    //   referrer,
    //   date,
    //   locale,
    //   utmMedium,
    //   utmChannel,
    //   utmCampaign,
    //   utmSource,
    //   utmTerm,
    //   utmId,
    // });
    localStorage.removeItem('prsID');
    segmentAnalytics.reset();
  });
}




 
const handleNotifyInStock = (data: any) => {
  const { path, url, referrer, date, locale, utmMedium, utmChannel, utmCampaign, utmSource, productData, currency, category, utmId, utmTerm } = data;
  document.addEventListener("click", (event) => {

    const price = productData?.price || 0;
    const name = productData?.title || '';
    const variant = productData?.variants[0]?.id || '';

    const product: Products = {
      currency: currency,
      price: price ? parseFloat((Number(price) / 100).toFixed(2)) : 0.00,
      quantity: 1,
      variant: variant,
      category: category,
      position: 1,
      productName: name,
      productType: productData?.type?.includes('Software') || productData?.type?.includes('Subscription') ? 'digital' : 'physical',
      upsell: false,
      sku: productData?.variants[0]?.sku || '',
      productId: productData?.id
    };

    const target = event.target as HTMLElement;
    if (target?.classList.contains("restock-alerts-submit-button")) {
      loadSegmentAnalytics();
      Avo.notifyInStock({
        name,
        path,
        url,
        referrer,
        date,
        locale,
        utmMedium,
        utmChannel,
        utmCampaign,
        utmId,
        utmTerm,
        utmSource,
        products: [product],
        categoryTag: productData.tags || [] as string[],
        sectionId: 'shop'
      });
    }
  }
  );
}


window.onload = () => {
  setShopifyCustomPixelValues();
  loadSegmentAnalytics();
  const commonData = collectCommonData();
  handleLoadedAPage(commonData);
  handleProductViewed(commonData);
  handleCartViewed(commonData);
  handleNavigationClicked(commonData);
  // handleProductAdded(commonData);
  handleDealerLocatorEvents(commonData);
  handleProductSearched(commonData);
  handleFilterChange(commonData);
  handlePromotionClicked(commonData);
  handleSrcCode();
  handleLoggedIn(commonData);
  handleLoggedOut(commonData);
  handleRecommendationClicked(commonData);
  handleNotifyInStock(commonData);
};
